import { useNavigateTo } from '@/routes/hooks/use-navigate-to';
import { modalState } from '@/state/modal.state';
import { useProjectListingsSectionParams } from '../projects/project-listings/use-project-listings-section-params';
import { useSetAtom } from 'jotai';

type searchItemType = 'company' | 'project' | 'team';

export const useNavigateToSearchItemPage = () => {
  const navigateTo = useNavigateTo();
  const listingsSectionParams = useProjectListingsSectionParams();
  const setModal = useSetAtom(modalState);

  const navigateToSearchItemPage = ({
    type,
    id,
  }: {
    type: searchItemType;
    id: string;
  }) => {
    switch (type) {
      case 'company':
        return navigateTo.company({ companyId: id });
      case 'project':
        return navigateTo.project({ projectId: id }, listingsSectionParams);
      case 'team':
        return navigateTo.team({ teamId: id });
    }
  };

  return ({ type, id }: { type: searchItemType; id: string }) => {
    setModal(null);
    navigateToSearchItemPage({ type, id });
  };
};
